module.exports =
  artwork:
    holdList: '/query/artwork/holdList'
    uploadImage: '/query/artwork/uploadImage'
    hold: '/query/artwork/hold'
    release: '/query/artwork/release'
  autoPrinter:
    search: '/query/autoPrinter/search'
    create: '/query/autoPrinter/create'
    detail: '/query/autoPrinter/detail/:autoPrinterId'
  autoprintSheet:
    detail: '/query/autoprintSheet/detail/:autoprintSheetId'
    family: '/query/autoprintSheet/family/:autoprintSheetId'
    status: '/query/autoprintSheet/status/:autoprintSheetId'
    barcode: '/query/autoprintSheet/barcode/:barcode'
    search: '/query/autoprintSheet/search'
    next: '/query/autoprintSheet/next'
    priorityCount: '/query/autoprintSheet/priorityCount'
    prioritize: '/query/autoprintSheet/prioritize/:autoprintSheetId'
    unprioritize: '/query/autoprintSheet/unprioritize/:autoprintSheetId'
    stageByRip: '/query/autoprintSheet/stageByRip'
    stageByOrderPart: '/query/autoprintSheet/stageByOrderPart'
    priorityQueue: '/query/autoprintSheet/priorityQueue'
    immediatePrint: '/query/autoprintSheet/immediatePrint/:autoprintSheetId'
  autoprintRip:
    detail: '/query/autoprintRip/detail/:autoprintRipId'
    bulkById: '/query/autoprintRip/bulkById'
  blankOrderItem:
    createManual: '/query/blankOrderItem/createManual'
    findActiveByOrderPart: '/query/blankOrderItem/findActiveByOrderPart/:orderPartId'
    cancelByOrderPart: '/query/blankOrderItem/cancelByOrderPart'
    bulkCancel: '/query/blankOrderItem/bulkCancel'
  orderPartRejection:
    bulkCancel: '/query/orderPartRejection/bulkCancel'
    bulkByOrderPartId: '/query/orderPartRejection/bulkByOrderPartId/:orderPartId'
  box:
    barcode: '/query/box/barcode/:barcode'
    bulkById: '/query/box/bulkById'
    location: '/query/box/location/:location'
    orderPartIds: '/query/box/orderPartIds'
    updateLocation: '/query/box/updateLocation/:boxId'
    markMissing: '/query/box/markMissing/:boxId'
    remove: '/query/box/remove/:boxId'
    create: '/query/box/create'
    storeInstruction: '/query/box/storeInstruction/:boxId'
  health:
    base: '/query/__health'
    metrics: '/query/__health/metrics'
  rack:
    shipping:
      marshalOrderPartsByBarcode: '/query/rack/shipping/:shippingFormId/marshalOrderPartsByBarcode'
      transfer: '/query/rack/shipping/:rackId/bin/:bin/transfer'
    bulkByBarcode: '/query/rack/bulkByBarcode'
  customization:
    orderPart:
      status: '/query/customization/orderPart/:orderPartId/status'
    shippingForm:
      status: '/query/customization/shippingForm/:shippingFormId/status'
    assemblyItem:
      status: '/query/customization/assemblyItem/:assemblyItemId/status'
  printEmbr:
    hold: '/query/printEmbr/hold'
  ripProfile:
    detail: '/query/ripProfile/:ripProfileId'
    byRipProfileGroupId: '/query/ripProfile/ripProfileGroup/:ripProfileGroupId'
    bulkById: '/query/ripProfile/bulkById'
    search: '/query/ripProfile/-/search'
    create: '/query/ripProfile/create'
    update: '/query/ripProfile/:ripProfileId/update'
    delete: '/query/ripProfile/:ripProfileId/delete'
  ripProfileGroup:
    detail: '/query/ripProfileGroup/:ripProfileGroupId'
    bulkById: '/query/ripProfileGroup/bulkById'
    create: '/query/ripProfileGroup/create'
    search: '/query/ripProfileGroup/-/search'
    update: '/query/ripProfileGroup/:ripProfileGroupId/update'
    delete: '/query/ripProfileGroup/:ripProfileGroupId/delete'
    configuration: '/query/ripProfileGroup/:ripProfileGroupId/configurationSetting'
  storageRack:
    base: '/query/storageRack'
    storeInstruction: '/query/storageRack/storeInstruction'
    store: '/query/storageRack/store'
    labelData: '/query/storageRack/labelData/:rackId'
    clear: '/query/storageRack/clear'
    locationByOrderPart: '/query/storageRack/locationByOrderPart'
    shippingForms: '/query/storageRack/shippingForms/:rackId'
    shippingStatus: '/query/storageRack/shippingStatus/:rackId'
    findByShippingFormId: '/query/storageRack/findByShippingFormId/:shippingFormId'
  storageBin:
    findByRackId: '/query/storageBin/findByRackId/:rackId'
  preprintStoreBin:
    pullList: '/query/preprintStoreBin/pullList'
    pull: '/query/preprintStoreBin/pull'
    return: '/query/preprintStoreBin/return'
    forcePull: '/query/preprintStoreBin/forcePull'
  orderForm:
    detail: '/query/orderForm/:orderFormId'
    history: '/query/orderForm/:orderFormId/history'
    shipStatus: '/query/orderForm/:orderFormId/shipStatus'
  orderFormRun:
    detail: '/query/orderFormRun/:orderFormRunId'
    barcode: '/query/orderFormRun/barcode/:barcode'
    orderForm: '/query/orderFormRun/orderForm/:orderFormId'
    qcStatus: '/query/orderFormRun/qcStatus/:orderFormRunId'
    itemStatus: '/query/orderFormRun/itemStatus/:orderFormRunId'
    screenprint:
      qcComplete: '/query/orderFormRun/qcComplete/:orderFormRunId'
      qcIncomplete: '/query/orderFormRun/qcIncomplete/:orderFormRunId'
    shipping:
      shipComplete: '/query/orderFormRun/shipComplete/:orderFormRunId'
    search: '/query/orderFormRun/-/search'
    pressSetup: '/query/orderFormRun/pressSetup/:orderFormRunId'
    qcBulkApprove: '/query/orderFormRun/qcBulkApprove/:orderFormRunId'
    bulkMarshalComplete: '/query/orderFormRun/bulkMarshalComplete/:orderFormRunId'
  orderPart:
    prioritize: '/query/orderPart/prioritize'
    ripStatus: '/query/orderPart/:orderPartId/ripStatus'
    stockStatus: '/query/orderPart/:orderPartId/stockStatus'
    rejectItem: '/query/orderPart/:orderPartId/rejectItem'
    status: '/query/orderPart/:orderPartId/status'
    artworkId: '/query/orderPart/artworkId/:artworkId'
    specialInstruction: '/query/orderPart/:orderPartBarcode/specialInstruction'
    convertToDtg: '/query/orderPart/convertToDtg'
    statusUpdate: '/query/orderPart/statusUpdate'
    bulkByStatus: '/query/orderPart/bulkByStatus'
  orderPartItem:
    count: '/query/orderPartItem/count'
  printPart:
    bulkByIdentifiers: '/query/printPart/bulkByIdentifiers'
    bulkByUserId: '/query/printPart/bulkByUserId/:userId'
  shippingForm:
    switchFacility: '/query/shippingForm/:shippingFormId/switchFacility'
    qcAudit:
      kickOutForm: '/query/shippingForm/:shippingFormId/qcAudit/kickOutForm'
      markAudited: '/query/shippingForm/:shippingFormId/qcAudit/markAudited'
    serviceCarrier: '/query/shippingForm/:shippingFormId/serviceCarrier'
  fulfillment:
    getNext: '/query/fulfillment/getNext'
    decrementStock: '/query/fulfillment/decrementStock'
  data:
    artwork:
      detail: '/query/data/artwork/:artworkId'
      bulk: '/query/data/artwork/bulk'
    artworkConversion:
      detail: '/query/data/artworkConversion/:conversionId'
      search: '/query/data/artworkConversion/search'
      bulk: '/query/data/artworkConversion/bulk'
    autoPrint:
      detail: 'query/data/autoPrint/:autoPrintId'
    autoPrintSheet:
      detail: 'query/data/autoPrintSheet/:autoPrintSheetId'
    productItem:
      search: '/query/data/productItem/search'
      detail: '/query/data/productItem/:productItemId'
      bulk: '/query/data/productItem/bulk'
      product: '/query/data/productItem/product/:productId'
      gtin: '/query/data/productItem/gtin/:gtin'
      code: '/query/data/productItem/code/:code'
    product:
      detail: '/query/data/product/:productId'
      bulk: '/query/data/product/bulk'
      all: '/query/data/product/all'
      search: '/query/data/product/search'
      bulkOoProductIds: '/query/data/product/bulkOoProductIds'
      identifier: '/query/data/product/identifier/:productIdentifier'
      legacy: '/query/data/product/legacy/:ooProductId'
    order:
      detail: '/query/data/order/:orderId'
      bulk: '/query/data/order/bulk'
      breakdown: '/query/data/order/breakdown'
      reference: '/query/data/reference/:referenceId'
      stuck: '/query/data/order/stuck'
      printing: '/query/data/order/printing'
      flow: '/query/data/order/flow'
      query: '/query/data/order/query'
      shipment:
        group: '/query/data/order/:orderId/shipment/group'
      tracking: '/query/data/order/tracking/:trackingNumber'
      checkReference: '/query/data/order/checkReference/:checkReference'
    orderEvent:
      query: '/query/data/orderEvent/query'
    employee:
      all: '/query/data/employee/all'
      search: '/query/data/employee/search'
      upsert: '/query/data/employee/upsert'
      present: '/query/data/employee/present'
    employeeLog:
      search: '/query/data/employeeLog/search'
      performance: '/query/data/employeeLog/performance'
    employeeShift:
      search: '/query/data/employeeShift/search'
    user:
      base: '/query/data/user'
      internal: '/query/data/user/internal'
      search: '/query/data/user/search'
      bulk: '/query/data/user/bulk'
      detail: '/query/data/user/:userId'
      orders: '/query/data/user/:userId/orders'
      designs: '/query/data/user/:userId/designs'
      productCount: '/query/data/user/:userId/productCount'
      salesRep: '/query/data/user/salesRep'
      linkLead: '/query/data/user/:userId/lead/:leadId/link'
      affiliationGroups: '/query/data/user/affiliationGroups'
      referrer: '/query/data/user/referrer'
      subUsers: '/query/data/user/subUsers'
      activate: '/query/data/user/:userId/activate'
      deactivate: '/query/data/user/:userId/deactivate'
    orderForm:
      reference: '/query/data/orderForm/reference/:referenceId'
      bulk: '/query/data/orderForm/bulk'
      referenceBulk: '/query/data/orderForm/referenceBulk'
      operationHold: '/query/data/orderForm/:orderFormId/operationHold'
    design:
      detail: '/query/data/design/:designId'
      bulk: '/query/data/design/bulk'
      orders: '/query/data/design/:designId/orders'
    printPart:
      base: '/query/data/printPart'
      detail: '/query/data/printPart/:printPartId'
      bulk: '/query/data/printPart/bulk'
    report:
      query: '/query/data/report/query'
    queueJob:
      detail: '/query/data/queueJob/:jobId'
      bulk: '/query/data/queueJob/bulk'
      clear: '/query/data/queueJob/clear'
    pricing:
      base: '/query/data/pricing'
      detail: '/query/data/pricing/:pricingId'
    shippingForm:
      detail: '/query/data/shippingForm/:shippingFormId'
      bulk: '/query/data/shippingForm/bulk'
      bulkById: '/query/data/shippingForm/bulkById'
      bulkByOrderFormId: '/query/data/shippingForm/bulkByOrderFormId'
      bulkOrderDetails: '/query/data/shippingForm/bulkOrderDetails'
      children: '/query/data/shippingForm/:shippingFormId/children'
      byOrderId: '/query/data/shippingForm/byOrderId/:orderId'
    tracking:
      bulk: '/query/data/tracking/bulk'
    billing:
      detail: '/query/data/billing/:billingId'
      transactions: '/query/data/billing/:billingId/transactions'
      balance: '/query/data/billing/:billingId/balance'
    setting:
      base: '/query/data/setting'
      cartId: '/query/data/setting/cartId'
      palletId: '/query/data/setting/palletId'
      casePrinting: '/query/data/setting/casePrinting'
      qcAudit: '/query/data/setting/qcAudit'
      orderApprovalUsers: '/query/data/setting/orderApprovalUsers'
      facilityCapacity: '/query/data/setting/facilityCapacity'
      facilityMinimumThroughput: '/query/data/setting/facilityMinimumThroughput'
      facilityPriority: '/query/data/setting/facilityPriority'
    facilityCapacity:
      create: '/query/data/facilityCapacity/create'
    rack:
      base: '/query/data/racks/:rackId'
      name: '/query/data/racks/name/:rackName'
      query: '/query/data/racks/query/:facility'
      bulkBarcodes: '/query/data/racks/bulkBarcode'
    orderPart:
      statusCount: '/query/data/orderPart/statusCount'
      detail: '/query/data/orderPart/:orderPartId'
      bulk: '/query/data/orderPart/bulk'
      bulkByBarcode: '/query/data/orderPart/bulkByBarcode'
      barcode: '/query/data/orderPart/barcode/:barcode'
      query: '/query/data/orderPart/query'
      bulkBarcodes: '/query/data/orderPart/bulkBarcode'
      images: '/query/data/orderPart/:orderPartId/images'
      personalization: '/query/data/orderPart/:orderPartId/personalization'
      bulkFormIds: '/query/data/orderPart/bulkFormIds'
      shippingFormId: '/query/data/orderPart/shippingForm/:shippingFormId'
      ooOrderId: '/query/data/orderPart/ooOrderId/:ooOrderId'
      orderId: '/query/data/orderPart/orderId/:orderId'
      bulkStoredStatus: '/query/data/orderPart/bulkStoredStatus'
      counter: '/query/data/orderPart/:orderPartId/counter'
      ripId: '/query/data/orderPart/ripId/:ripId'
      ripIdBulk: '/query/data/orderPart/ripIdBulk'
      orderPartItem: '/query/data/orderPart/:orderPartId/orderPartItem'
    claim:
      base: '/query/data/claim'
      count: '/query/data/claim/count'
      search: '/query/data/claim/search'
      detail: '/query/data/claim/:claimId'
      status: '/query/data/claim/status/:status'
      report: '/query/data/claim/report'
    orderPartRejection:
      base: '/query/data/orderPartRejection'
      byType: '/query/data/orderPartRejection/byType/:type'
    shopifyItem:
      bulkByVariantId: '/query/data/shopifyItem/bulkByVariantId'
    shopifyLineItem:
      bulkByShopifyLineItemId: '/query/data/shopifyLineItem/bulkByShopifyLineItemId'
    salesReportSetting:
      base: '/query/data/salesReportSetting'
    salesReps:
      base: '/query/data/salesReps'
    inventoryLog:
      query: '/query/data/inventoryLog/query'
    inventoryRack:
      base: '/query/data/inventoryRack/:rackId'
      query: '/query/data/inventoryRack/query/:facility'
    rip2:
      hold: '/query/data/rip2/hold'
    invoice:
      byOrderId: '/query/data/byOrderId/billing/:billingId/orderId/:orderId'
  orderLog:
    latest: '/query/orderLog/latest'
  employeeShift:
    detail: '/query/employeeShift/detail/:employeeShiftId'
    logs: '/query/employeeShift/logs/:employeeShiftId'
    aggregateScans: '/query/employeeShift/aggreagateScans'
  assembly:
    assemblyItem:
      barcode: '/query/assembly/assemblyItem/barcode/:barcode'
      create: '/query/assembly/assemblyItem/create'
      detail: '/query/assembly/assemblyItem/detail/:assemblyItemId'
      history: '/query/assembly/assemblyItem/history/:barcode'
      pendingRejectionApproval: '/query/assembly/assemblyItem/pendingRejectionApproval'
      shipmentStatus: '/query/assembly/assemblyItem/shipmentStatus/:assemblyItemId'
      status:
        item: '/query/assembly/assemblyItem/status/item'
        items: '/query/assembly/assemblyItem/status/items'
      assemblyQueueJob: '/query/assembly/assemblyItem/assemblyQueueJob/:assemblyItemId'
    assemblyQueue:
      count: '/query/assembly/assemblyQueue/count'
      bulkCount: '/query/assembly/assemblyQueue/bulkCount'
      positions: '/query/assembly/assemblyQueue/positions'
      update: '/query/assembly/assemblyQueue/update'
  mockupTemplate:
    base: '/query/mockupTemplate'
    bulk: '/query/mockupTemplate/bulk'
    search: '/query/mockupTemplate/search'
    byIdentifier: '/query/mockupTemplate/byIdentifier'
    bulkByIdentifier: '/query/mockupTemplate/bulkByIdentifier'
  boxRack:
    search: '/query/boxRack/search'
  externalBlankOrder:
    detail: '/query/externalBlankOrder/detail/:externalBlankOrderId'
    bulk: '/query/externalBlankOrder/bulk'
  inventoryBlankOrder:
    base: '/query/inventoryBlankOrder'
    barcode: '/query/inventoryBlankOrder/barcode/:barcode'
    edit: '/query/inventoryBlankOrder/:inventoryBlankOrderId/edit'
    search: '/query/inventoryBlankOrder/search'
    cancel: '/query/inventoryBlankOrder/cancel'
    itemCount: '/query/inventoryBlankOrder/itemCount'
    receive: '/query/inventoryBlankOrder/receive'
  embr:
    matrix2:
      matrixCode: '/query/embr/matrix2/matrixCode/:matrixCode'
      colorCodes: '/query/embr/matrix2/colorCodes'
      lock: '/query/embr/matrix2/lock'
  external:
    inkpop:
      order:
        orderReleased: '/query/external/inkpop/order/orderReleased/:spOrderId'
  shipping:
    label: '/query/shipping/:formId/label'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/query.coffee